import { WarningOutlined } from "@mui-symbols-material/w300"
import { type ColumnDef, type Row } from "@tanstack/react-table"
import React from "react"
import type { UseQueryExecute } from "urql"

import type { Instruction } from "@/graphql/codegen/graphql"
import {
  renderApplicableToCell,
  renderDescriptionCell,
  renderHazardousCell,
  renderIncludeWithCell,
  renderTransportationModeCell,
} from "@/screens/ManageProducts/components/Instructions/hooks/useInstructionsColumns"
import { ProductActions } from "@/screens/Products/components/Product/Instructions/components/rowActions/ProductActions"

const useColumns = ({
  productId,
  refetchInstructionsList,
}: {
  productId: number
  refetchInstructionsList: UseQueryExecute
}): ColumnDef<Instruction>[] => {
  return [
    {
      accessorKey: "applicableTo",
      header: "Applicable To",
      cell: renderApplicableToCell,
      enableSorting: false,
      size: 120,
    },
    {
      accessorKey: "transportationMode",
      header: "Transportation Mode",
      cell: renderTransportationModeCell,
      enableSorting: false,
      size: 150,
    },
    {
      accessorKey: "includeWith",
      header: "Include With",
      cell: renderIncludeWithCell,
      enableSorting: false,
      size: 120,
    },
    {
      accessorKey: "isHazard",
      header: () => <WarningOutlined />,
      cell: renderHazardousCell,
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: "description",
      header: "Instructions",
      cell: renderDescriptionCell,
      enableSorting: false,
      size: 400,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }: { row: Row<Instruction> }) => (
        <ProductActions row={row} refetchInstructionList={refetchInstructionsList} productId={productId} />
      ),
      size: 50,
      enableSorting: false,
    },
  ]
}

export default useColumns
